
export default async function getPdf(uname, token, json) {
    return new Promise(function (resolve, reject) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify(json);
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };
        
        fetch("http://fixmeeting.eu/fixmeeting-pdfs/api/generate-pdf?font=Montserrat", requestOptions)
          .then(response => response.text())
          .then(result => resolve(result))
          .catch(error => {
            console.log('error', error)
          }); 
          
    });
}
